import script from "./PartnerRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerRequests.vue?vue&type=script&setup=true&lang=js"

import "./PartnerRequests.vue?vue&type=style&index=0&id=1424665c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1424665c"]])

export default __exports__